// extracted by mini-css-extract-plugin
export default {"link":"ndwBfX","active":"dXLKh7"};